import { LifepackPrescriptionStatus } from 'Constants/consults';
import React from 'react';

import ErrorMessage from './ErrorMessage';
import WarningMessage from './WarningMessage';

interface LifepackMessageProps {
  lifepackPrescriptionStatus: keyof typeof LifepackPrescriptionStatus;
  lifepackCancellationReason: string | null;
}

const LifepackMessage: React.FC<LifepackMessageProps> = ({
  lifepackPrescriptionStatus,
  lifepackCancellationReason,
}) => {
  if (
    [
      LifepackPrescriptionStatus.PRESCRIPTION_ADJUSTED,
      LifepackPrescriptionStatus.PRESCRIPTION_APPROVED,
    ].includes(lifepackPrescriptionStatus)
  ) {
    return <WarningMessage message="Prescription was adjusted by pharmacist" />;
  }

  if (
    [
      LifepackPrescriptionStatus.PRESCRIPTION_REJECTED,
      LifepackPrescriptionStatus.ORDER_CANCELLED,
      LifepackPrescriptionStatus.PAYMENT_FAILED,
    ].includes(lifepackPrescriptionStatus)
  ) {
    return (
      <ErrorMessage
        title="Prescription Cancelled"
        message={`Reason of Cancellation: ${lifepackCancellationReason || ''}`}
      />
    );
  }

  return null;
};

export default LifepackMessage;
